import React, { useState } from "react";
import close from "../../../../assets/img/icons/Vector copy.svg";
import useFetch from "../../../../hooks/useAxios";
import arrow from "../../../../assets/img/icons/arrow-left-green.svg";
import Input from "../../../shared/Input";
import Button from "../../../shared/Button";
import CityModal from "./CityModal";

const StateModal = ({ closeModal, dropbox, chosenCity, setChoseCity,setChoseState,ChoseState,setDropbox ,setchoseCityId,choseCityId,setStateinfo,setStateResults ,StateResults,Stateinfo}) => {
  const [isState, setIsState] = useState(true);
  const [ChoseStateid, setChoseStateid] = useState(null);


  const apiCityInfo = useFetch({
    method: "get",
    url: "api/locations",
    noHeader: true,
    trigger: true,
    argFunc: res => {
      setStateinfo(res.data);
      setStateResults(res.data);
    }
  });
  const findState = e => {
    setStateinfo(StateResults.filter(i => i.name.startsWith(e.target.value)));
    // if(e.target.value === ""){
    //     setStateinfo([...StateResults])
    // }
  };
  const chooseState = id => {
    setChoseStateid(id);
    setChoseState(Stateinfo.filter(i => i.id === id));
  };

  return (
    <div
      className={`CityBox dropbox-absolute  ${dropbox === "city"
        ? "box-show z-[999]"
        : "box-hidden "}`}
      onClick={e => e.stopPropagation()}
    >
      {isState
        ? <div>
            <div className="flex justify-between  items-center">
              <div className="flex justify-between  items-center gap-[8px]">
                <h2 className="text-[#292D32] text-[20px] font-[700]">
                  لیست شهر ها
                </h2>
              </div>

              <button onClick={()=>setDropbox("")}>
                <img src={close} />
              </button>
            </div>
            <hr className="my-[10px]" />
            <div className={`Input relative `}>
              <input
                placeholder="شهر مورد نظر را جستجو کنید"
                onChange={e => findState(e)}
              />
            </div>
            <div className="StateModal-body pb-[80px]">
              {Stateinfo.map(i =>
                <div
                  className={`StateModal-box ${i.id === ChoseStateid
                    ? "StateModal-box--active"
                    : ""}`}
                    key={i.id}
                  onClick={() => chooseState(i.id)}
                >
                  <div>
                    <h4>
                      {i.name}
                    </h4>
                    <p>
                      {i.cities[0].title},{i.cities[1].title},{i.cities[2].title}
                    </p>
                  </div>
                  <div className="flex items-center gap-[8px]">
                    <div className="StateModal-box--residencecount">
                      {i.residences_count} اقامتگاه
                    </div>
                    <img src={arrow} />
                  </div>
                </div>
              )}
            </div>
            <div className="flex StateModal-buttonrow">
              <Button varient="white" onClick={()=>setDropbox("")}>انصراف</Button>

              <Button
                varient="primary"
                onClick={() => {
                  if (ChoseStateid) {
                    setIsState(false);
                  }
                }}
              >
                تایید مقصد
              </Button>
            </div>
          </div>
        : <CityModal
            setChoseCity={setChoseCity}
            closeModal={()=>setDropbox("")}
            ChoseState={ChoseState}
            chosenCity={chosenCity}
            setIsState={setIsState}
            setchoseCityId={setchoseCityId} choseCityId={choseCityId}
          />}
    </div>
  );
};

export default StateModal;
